/*
 * Module for the Add Vendor Page
*/

rs.module("vendor/addvendor",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        var _jsSelectors;
        var _cssClasses;
        var _codeValues;
        var _backendUrls;
        var _form;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, codeValues, backendUrls, duplicateVendorLookup) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _codeValues = codeValues;
            _backendUrls = backendUrls;

            _form = $.js(_jsSelectors.form);

            // Register click event for changing identity once an identity has previously been verified
            _form.js(_jsSelectors.changeIdentityLink).click(function () { _togglePageForIdentityVerified(false); });

            // Register click event for vendor type radio buttons 
            _form.js(_jsSelectors.vendorTypeRadioContainer).find("input").on("click", () => _onVendorTypeChanged());

            // Register change event for payment method select
            _form.js(_jsSelectors.paymentMethodSelect).change(_enableDisablePaymentMethodFields);

            // Tell duplicate lookup where to pull lookup parameters from
            duplicateVendorLookup.onGetLookupParameters(function () {

                // Validate form before performing duplicate lookup
                var validator = _form.validate();
                var isValid = validator.form();

                // only send lookup parameters if form is valid
                if (isValid) {

                    // get selected vendor type
                    var selectedVendorType = _form.js(_jsSelectors.vendorTypeRadioContainer).find("input:checked").val();

                    // derive TIN value for duplicate check based on vendor type
                    var tinValue;
                    if (selectedVendorType == codeValues.individual) {
                        tinValue = _form.js(_jsSelectors.ssnInput).val().replace(/-/g, "").replace(/ /g, "");
                    }
                    else {
                        tinValue = _form.js(_jsSelectors.tinInput).val().replace(/-/g, "").replace(/ /g, "");
                    }

                    return {
                        vendorType: selectedVendorType,
                        firstName: _form.js(_jsSelectors.firstNameInput).val().trim(),
                        middleName: _form.js(_jsSelectors.middleNameInput).val().trim(),
                        lastName: _form.js(_jsSelectors.lastNameInput).val().trim(),
                        entityName: _form.js(_jsSelectors.nameInput).val().trim(),
                        tin: tinValue,
                        fundKey: _form.js(_jsSelectors.fundSelect).val()
                    };
                }

                return null;
            });

            // Hookup callback function to be executed when duplicate selection is complete
            duplicateVendorLookup.onDuplicateSelectionComplete(_duplicateSelectionComplete);
        }

        //
        // Callback to execute when duplicate selection is complete
        //
        function _duplicateSelectionComplete(vendorPartyKey) {

            // get selected vendor type
            var selectedVendorType = _form.js(_jsSelectors.vendorTypeRadioContainer).find("input:checked").val();

            // set hidden fields to be able to post values back on save since we will be disabling the identity fields
            _form.js(_jsSelectors.vendorTypeInputHidden).val(selectedVendorType);
            _form.js(_jsSelectors.vendorCategoryInputHidden).val(_form.js(_jsSelectors.vendorCategorySelect).val());
            _form.js(_jsSelectors.nameInputHidden).val(_form.js(_jsSelectors.nameInput).val().trim());
            _form.js(_jsSelectors.tinInputHidden).val(_form.js(_jsSelectors.tinInput).val().trim());
            _form.js(_jsSelectors.firstNameInputHidden).val(_form.js(_jsSelectors.firstNameInput).val().trim());
            _form.js(_jsSelectors.middleNameInputHidden).val(_form.js(_jsSelectors.middleNameInput).val().trim());
            _form.js(_jsSelectors.lastNameInputHidden).val(_form.js(_jsSelectors.lastNameInput).val().trim());
            _form.js(_jsSelectors.ssnInputHidden).val(_form.js(_jsSelectors.ssnInput).val().trim());
            _form.js(_jsSelectors.fundInputHidden).val(_form.js(_jsSelectors.fundSelect).val());

            // If an existing vendor was not selected
            if (vendorPartyKey == -1) {

                // reset fields for a new vendor
                _resetFieldsForNoMatch();
            }
            else {

                // Retrieve existing vendor info
                $.get(_backendUrls.loadExistingVendorInfo,
                    {
                        vendorPartyKey: vendorPartyKey

                    }).done(function (result) {

                        // populate identity inputs with the retrieved info for the duplicate vendor
                        _form.js(_jsSelectors.vendorPartyKeyHidden).val(vendorPartyKey);

                        if (selectedVendorType == _codeValues.individual) {

                            // populate identity inputs with the retrieved info for the duplicate vendor (person)
                            _form.js(_jsSelectors.firstNameInput).val(result.participant.person.firstName);
                            _form.js(_jsSelectors.middleNameInput).val(result.participant.person.middleName);
                            _form.js(_jsSelectors.lastNameInput).val(result.participant.person.lastName);
                            _form.js(_jsSelectors.ssnInput).val(result.participant.person.ssn);

                            // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                            _form.js(_jsSelectors.firstNameInputHidden).val(result.participant.person.firstName);
                            _form.js(_jsSelectors.middleNameInputHidden).val(result.participant.person.middleName);
                            _form.js(_jsSelectors.lastNameInputHidden).val(result.participant.person.lastName);
                            _form.js(_jsSelectors.ssnInputHidden).val(result.participant.person.ssn);
                        }
                        else {

                            // populate identity inputs with the retrieved info for the duplicate vendor (nonPerson)
                            _form.js(_jsSelectors.nameInput).val(result.participant.nonPerson.name);
                            _form.js(_jsSelectors.tinInput).val(result.participant.nonPerson.tin);

                            // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                            _form.js(_jsSelectors.nameInputHidden).val(result.participant.nonPerson.name);
                            _form.js(_jsSelectors.tinInputHidden).val(result.participant.nonPerson.tin);
                        }

                        // hide/clear contact info fields and display message
                        visibility.setVisible(_form.js(_jsSelectors.contactInfo), false);
                        visibility.setVisible(_form.js(_jsSelectors.contactInfoMessage), true);
                        _clearContactInfoFields();

                        // Once all inputs are populated toggle sections/fields for identity verified
                        _togglePageForIdentityVerified(true);
                    });
            }

            // Move focus to Status field in Detail section for quicker data entry
            _form.js(_jsSelectors.statusSelect).focus();
        }

        //
        // Enable/disable sections based on whether identity has been verified
        //
        function _togglePageForIdentityVerified(identityVerified) {

            _form.js(_jsSelectors.identityVerified).val(identityVerified);
            _form.js(_jsSelectors.saveButton).setDisabled(!identityVerified);

            _toggleIdentitySection(!identityVerified);
            _toggleDetailSection(identityVerified);
            _toggleContactInfoSection(identityVerified);

            _resetValidations();
        }

        //
        // Enable/disable the identity section
        //
        function _toggleIdentitySection(enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(_jsSelectors.identity).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable);

            // Have to use select helper to enable/disable any selects
            _form.js(_jsSelectors.identity).find("select").each(function () {
                $(this).attr("data-val", enable);
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });

            _form.js(_jsSelectors.duplicateVendorLookup).toggle(enable);
            _form.js(_jsSelectors.changeIdentityLink).toggleClass(_cssClasses.visible, !enable);
        }
     
        //
        // Enable/disable the detail section
        //
        function _toggleDetailSection(enable) {

            if (enable) {

                _toggleSectionFields(_jsSelectors.detail, true);

                // enable/disable payment method fields if payment method is not ACH
                _enableDisablePaymentMethodFields();

                // enable/disable state tax agency fields if vendor category is state tax agency
                _enableDisableStateTaxAgencyFields();

                // populate banks based on user selected fund
                _populateBanks();
            }
            else {
                _toggleSectionFields(_jsSelectors.detail, false);
            }
        }

        //
        // Enable/disable the contact info section
        //
        function _toggleContactInfoSection(enable) {

            _toggleSectionFields(_jsSelectors.contactInfo, enable);

            // Certain Address, Phone and Email inputs are unique, we always want data-val=false due to the conditional nature of their validations
            _form.js(_jsSelectors.addressInput, { multiple: true }).attr("data-val", false);
            _form.js(_jsSelectors.phoneInput, { multiple: true }).attr("data-val", false);
            _form.js(_jsSelectors.emailInput, { multiple: true }).attr("data-val", false);
        }

        //
        // Helper method to enable/disable all fields in a section
        //
        function _toggleSectionFields(sectionSelector, enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(sectionSelector).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable).clearErrors();

            // Have to use select helper to handle any selects
            _form.js(sectionSelector).find("select").each(function () {
                $(this).attr("data-val", enable).clearErrors();
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });
        }

        //
        // Set up fields if there was no match selected
        //
        function _resetFieldsForNoMatch() {

            // reset vendorPartyKey to -1
            _form.js(_jsSelectors.vendorPartyKeyHidden).val(-1);

            // display contact info fields (hide message)
            visibility.setVisible(_form.js(_jsSelectors.contactInfoMessage), false);
            visibility.setVisible(_form.js(_jsSelectors.contactInfo), true);

            // default contact info values for user convinience
            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(_codeValues.usa);
            _form.js(_jsSelectors.countryCodeInput).val("1");

            _togglePageForIdentityVerified(true);
        }

        //
        // Clear contact info fields (used when changing the vendor's identity)
        //
        function _clearContactInfoFields() {
                            
            // clear address inputs 
            _form.js(_jsSelectors.address1Input).val(null);
            _form.js(_jsSelectors.address2Input).val(null);
            _form.js(_jsSelectors.cityInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.stateSelect)).setValue(null);
            _form.js(_jsSelectors.zipInput).val(null);
            selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(null);
            _form.js(_jsSelectors.mailStopInput).val(null);

            // clear phone inputs 
            _form.js(_jsSelectors.countryCodeInput).val(null);
            _form.js(_jsSelectors.areaCodeInput).val(null);
            _form.js(_jsSelectors.phoneNumberInput).val(null);
            _form.js(_jsSelectors.extensionInput).val(null);

            // clear email inputs 
            _form.js(_jsSelectors.emailInput).val(null);
        }

        //
        // Changed event for vendor type radio buttons
        //
        function _onVendorTypeChanged() {

            // get selected vendor type
            var selectedVendorType = _form.js(_jsSelectors.vendorTypeRadioContainer).find("input:checked").val();

            // reset identity fields 
            _form.js(_jsSelectors.nameInput).val(null).clearErrors();;
            _form.js(_jsSelectors.nameInputHidden).val(null);
            _form.js(_jsSelectors.tinInput).val(null).clearErrors();;
            _form.js(_jsSelectors.tinInputHidden).val(null);
            _form.js(_jsSelectors.firstNameInput).val(null).clearErrors();;
            _form.js(_jsSelectors.firstNameInputHidden).val(null);
            _form.js(_jsSelectors.middleNameInput).val(null).clearErrors();;
            _form.js(_jsSelectors.middleNameInputHidden).val(null);
            _form.js(_jsSelectors.lastNameInput).val(null).clearErrors();;
            _form.js(_jsSelectors.lastNameInputHidden).val(null);
            _form.js(_jsSelectors.ssnInput).val(null).clearErrors();
            _form.js(_jsSelectors.ssnInputHidden).val(null);

            visibility.setVisible(_form.js(_jsSelectors.organizationContainer), selectedVendorType != _codeValues.individual);
            visibility.setVisible(_form.js(_jsSelectors.individualContainer), selectedVendorType == _codeValues.individual);
        }

        //
        // Enable or disable the payment method fields in detail section (apply if payment method is ach)
        //
        function _enableDisablePaymentMethodFields() {

            var isPaymentMethodAch = _form.js(_jsSelectors.paymentMethodSelect).val() == _codeValues.ach;

            selectHelper.getHelper(_form.js(_jsSelectors.bankSelect)).setValue("").setDisabled(!isPaymentMethodAch);
            $(_form.js(_jsSelectors.bankSelect)).clearErrors();
            _form.js(_jsSelectors.accountNumberInput).prop("disabled", !isPaymentMethodAch).val("").clearErrors();
            selectHelper.getHelper(_form.js(_jsSelectors.accountTypeSelect)).setValue("").setDisabled(!isPaymentMethodAch);
            $(_form.js(_jsSelectors.accountTypeSelect)).clearErrors();
        }

        //
        // Enable or disable the state tax agency fields in detail section (apply if vendor category is state tax agency)
        //
        function _enableDisableStateTaxAgencyFields() {

            var isVendorStateTaxAgency = _form.js(_jsSelectors.vendorCategorySelect).val() == _codeValues.stateTaxAgency;

            selectHelper.getHelper(_form.js(_jsSelectors.reportingStateSelect)).setValue("").setDisabled(!isVendorStateTaxAgency);
            _form.js(_jsSelectors.reportingIdInput).prop("disabled", !isVendorStateTaxAgency).val("");
            selectHelper.getHelper(_form.js(_jsSelectors.reportingMethodSelect)).setValue("").setDisabled(!isVendorStateTaxAgency);
        }

        // Populate banks select in detail section based on fund selected in identity section
        function _populateBanks() {

            var fundKey = _form.js(_jsSelectors.fundSelect).val();

            selectHelper.getHelper(_form.js(_jsSelectors.bankSelect)).loadOptionsFrom(
                _backendUrls.getAvailableFinancialInstitutions,
                {
                    fundKey: fundKey
                },
                {
                    withBlank: true
                });
        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            $.validator.resetValidation(_form);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);